import React, { PropTypes } from "react";
import { BSModal } from "../common";
import { FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import { Field, reduxForm, change as changeFieldValue, formValueSelector } from "redux-form";
import { TextInput } from "../common/form";
import Recaptcha from "react-recaptcha";
import config from "config";
import { bindActionCreators } from "redux";
import { personalDataValidationRules } from "./personalDataValidationRules";
import validationUtils from "../../utils/ValidationUtils";

class PersonalDataFormVerification extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.updateCaptcha = this.updateCaptcha.bind(this);
        this.validateModalForm = this.validateModalForm.bind(this);
        this.onClose = this.onClose.bind(this);

        this.state = {
            isFormValid: false,
        };
    }

    componentWillMount() {
        const { languageCode } = this.props;
        if (!document.getElementById("reCaptchaV2")) {
            const script = document.createElement("script");
            script.id = "reCaptchaV2";
            script.src = `https://www.google.com/recaptcha/api.js?render=explicit&hl=${languageCode}`;
            script.async = true;
            script.defer = true;
            document.body.appendChild(script);
        }
    }

    componentDidUpdate(prevProps) {
        if (
            prevProps.gRecaptchaResponse !== this.props.gRecaptchaResponse ||
            prevProps.checkCode !== this.props.checkCode
        ) {
            this.validateModalForm();
        }
    }

    updateCaptcha(value) {
        this.props.changeFieldValue("verificationCodeForm", "gRecaptchaResponse", value || null);
    }

    onClose() {
        const { changeFieldValue, closeModal } = this.props;

        changeFieldValue("verificationCodeForm", "gRecaptchaResponse", "");
        changeFieldValue("verificationCodeForm", "checkCode", "");
        /** Resetting modal's fields. */
        closeModal();
    }

    renderModalBody() {
        return (
            <form>
                <div>
                    <FormattedMessage id="personalData.form.verificationCodePopUp" />
                    <div className="verification-form">
                        <Field
                            id="checkCode"
                            name="checkCode"
                            component={TextInput}
                            label={<FormattedMessage id="personalData.form.verificationCodeLabel" />}
                        />
                        <div className="recaptcha-personal-data">
                            <Recaptcha
                                sitekey={config.recaptchaApiKey}
                                render="explicit"
                                expiredCallback={this.updateCaptcha}
                                verifyCallback={this.updateCaptcha}
                                onloadCallback={() => {
                                    /*will not load if this is not defined*/
                                }}
                            />
                            <Field
                                onChange={this.validateModalForm}
                                id="gRecaptchaResponse"
                                name="gRecaptchaResponse"
                                component={() => <span />}
                            />
                        </div>
                        <button onClick={this.props.recallCodeCheck} className="retry-check-code-btn">
                            <FormattedMessage id="personalData.form.retryCheckCode" />
                        </button>
                    </div>
                </div>
            </form>
        );
    }

    validateModalForm() {
        const { checkCode, gRecaptchaResponse } = this.props;
        this.setState({ isFormValid: checkCode && gRecaptchaResponse });
    }

    renderFormatedMessage(icon) {
        return <span className="icon warning">{icon}</span>;
    }
    
    render() {
        const { showModal, onSubmit, checkCode } = this.props;
        return (
            <BSModal
                backdrop={false}
                show={showModal}
                closeButtonKey="common.cancel"
                actions={[
                    {
                        id: 1,
                        disabled: !this.state.isFormValid,
                        text: <FormattedMessage id="common.confirm" />,
                        action: () => onSubmit({ checkCode }),
                    },
                ]}
                onClose={this.onClose}
                title={
                    <FormattedMessage id="personalData.form.verificationCodeModalTitle">
                        {this.renderFormatedMessage}
                    </FormattedMessage>
                }
            >
                {this.renderModalBody()}
            </BSModal>
        );
    }
}

function mapStateToProps(state) {
    const selector = formValueSelector("verificationCodeForm");

    return {
        gRecaptchaResponse: selector(state, "gRecaptchaResponse"),
        checkCode: selector(state, "checkCode"),
        languageCode: state.intl.locale,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        changeFieldValue: bindActionCreators(changeFieldValue, dispatch),
    };
}

PersonalDataFormVerification.propTypes = {
    showModal: PropTypes.bool,
    closeModal: PropTypes.func,
    handleSubmit: PropTypes.func,
    recallCodeCheck: PropTypes.func,
    changeFieldValue: PropTypes.func,
    languageCode: PropTypes.string,
    gRecaptchaResponse: PropTypes.string,
    checkCode: PropTypes.string,
    onSubmit: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps, null, {
    withRef: true,
})(
    reduxForm({
        form: "verificationCodeForm",
        validate: (values) => validationUtils.validate(values, personalDataValidationRules),
    })(PersonalDataFormVerification)
);



// WEBPACK FOOTER //
// ./src/components/personal-data/PersonalDataFormVerification.js